import { JOBS_REST_SEGMENT } from '@profilpublic/api-contract/job'

export function getCareerSiteUrl(careerSite) {
  const config = useRuntimeConfig()

  if (import.meta.dev) {
    return `${config.public.baseUrl}/career/${careerSite.slug}`
  } else if (import.meta.client && window.location.hostname.includes('vercel.app')) {
    return `https://${window.location.hostname}/career/${careerSite.slug}`
  }
  return `https://${config.public.careerDomain}/${careerSite.slug}`
}

export function getEmployerUrl(employer, toCareerSite = true) {
  if (toCareerSite && employer.careerSite?.active) {
    return getCareerSiteUrl(employer.careerSite)
  }
  return `/employeurs/${employer.slug}`
}

export function getJobUrl(job, toCareerSite = true) {
  if (toCareerSite && job.employer?.careerSite?.active) {
    return `${getCareerSiteUrl(job.employer.careerSite)}${getJobsUrl()}/${job.slug}`
  }
  return `${getJobsUrl()}/${job.slug}`
}

export function getJobsUrl() {
  return JOBS_REST_SEGMENT
}

export function getQuery(query) {
  return query ? '?' + new URLSearchParams(query).toString() : ''
}
